import React from "react";
import { useTranslation } from "react-i18next";
import ClaimsForm from "pages/Dashboard/DashboardClaims/ClaimsFormPage/ClaimsForm";
import SubmitClaimsCards from "./SubmitClaimsCards";
import tickCircleIcon from "assets/svg/claims/tick-circle-icon.svg";
import "./claimsSection.scss";

const TOP_FEATURES = [
  { id: "submit-track", labelKey: "claimsPage.topFeatures.submitTrack" },
  { id: "upload-missing", labelKey: "claimsPage.topFeatures.uploadMissing" },
  { id: "third-party-liability", labelKey: "claimsPage.topFeatures.thirdPartyLiability" },
  { id: "medical-claims", labelKey: "claimsPage.topFeatures.medicalClaims" },
];

const ClaimsSection = ({ setMenuOpen, calLem, TrackEvent, TrackEventWithProduct }) => {
  const { t } = useTranslation();

  return (
    <div className="claims-redesign-wrapper">
      {/* Left Panel */}
      <SubmitClaimsCards
        calLem={calLem}
        TrackEvent={TrackEvent}
        TrackEventWithProduct={TrackEventWithProduct}
      />

      {/* Right Panel */}
      <div className="check-status-panel">
        <h2 className="status-title">{t("claimsPage.checkClaimStatus")}</h2>
        
        <ClaimsForm />

        <div className="top-features-bar">
          <div className="features-heading">{t("claimsPage.topFeatures.title")}</div>
          <div className="features-list">
            {TOP_FEATURES.map((feature) => (
              <div key={feature.id} className="feature-item">
                <img src={tickCircleIcon} alt="tick" />
                <span>{t(feature.labelKey, feature.id)}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClaimsSection;